<script lang="ts">
    
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { storeMyArticles, storeArticlesError, storeArticle, storeEmptyArticle } from "../scripts/blog";
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { getArticlesOfAuthor } from '../scripts/apiArticles';
    import { addNotificationError }  from "../scripts/toaster";
    import { redirectTo } from "../scripts/router1";
    import { idPageArticle, idPageArticleEdition } from "../scripts/router2";
    import { storeIsLogin, storeUserLogin } from '../scripts/user';

    let myArticlesPending = [];
    let myArticlesWriting = [];
    let myArticlesPublished = [];

    onMount(async () => {
        window.scrollTo(0,0);
        getMyArticlesIfEmpty();
        storeMyArticles.subscribe(data => {
            myArticlesWriting = data.filter(item => {
                return item.id_article_status == 1;
            })
            myArticlesPending = data.filter(item => {
                return item.id_article_status == 2;
            })
            myArticlesPublished = data.filter(item => {
                return item.id_article_status == 3;
            })
        })
	});

    /**
     * getMyArticlesIfEmpty
     */
     function getMyArticlesIfEmpty() {
        if ($storeMyArticles.length <= 0) {
            if ($storeIsLogin) {
                const returnValue = getArticlesOfAuthor($storeUserLogin.id);
                returnValue.then((data) => {
                    if (!data) {
                        addNotificationError($storeArticlesError);
                    };
                });
            }
        }
    }

    /**
     * selectArticle
     * @param articleId
     */
    function selectArticle(articleId: number) {
        filterArticle(articleId);
        redirectTo(idPageArticle, "?id="+articleId);
    }

    /**
     * filterArticle
     * @param articleId
     */
    function filterArticle(articleId: number) {
        storeArticle.set($storeMyArticles.filter(item => {
            return (item.id == articleId);;
        })[0]);
    }

    /**
     * handleAnchorClick
     * @param anchorId
     */
     function handleAnchorClick (anchorId) {
		const anchor = document.getElementById(anchorId)
		window.scrollTo({
			top: anchor.offsetTop,
			behavior: 'smooth'
		})
	}

    function addArticle() {
        storeArticle.set({
    id: 0,
    title_fr: "",
    title_en: "",
    subtitle_fr: "",
    subtitle_en: "",
    text_fr: "",
    text_en: "",
    photo: "",
    url_article: "",
    id_author: 0,
    date_publication: "",
    id_article_status: 0,
    rate: 0,
    category: "",
    author: {
    id: 0,
    email: "",
    first_name: "",
    last_name: "",
    photo: "",
    enterprise: 0,
    linkedin: "",
    twitter: "",
    job: "",
    user_type: 0,
    active: 0,
    token: "",
},
});
        redirectTo(idPageArticleEdition);
    }
    
</script>
    
<style lang="scss">

    .blog {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__update {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            margin: 10px 0 10px 0;
        }
        &__status {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            margin: 0 0 60px 0;
            width: 100%;
            &__item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border: 1px solid $color-primary;
                color: $color-primary;
                margin: 15px 10px 15px 10px;
                padding: 5px 5px 5px 5px;
                min-width: 150px;
            }
        }

        &__statusbloc {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin: 60px 0 60px 0;
            background-color: $color-light-grey;
            box-shadow: 0px 0px 8px $color_text;
            border-radius: 10px;
            &__title {
                padding: 30px 0 30px 0;
            }
        }
        &__articles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
            width: 100%;
        }
        &__article {
            width: 90%;
            margin: 0 0 50px 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            background-color: $color-light-grey;
            box-shadow: 8px 8px 8px $color_text;
            border-radius: 20px 20px 20px 20px;
            min-height: 317px;
            &__photo {
                width: 100%;
                display: flex;
                flex-direction: column;;
                justify-content: center;
                align-items: center;
                &__img {
                    object-fit: cover;
                    object-position: 50% 0;
                    height: 167px;
                    width: 100%;
                    border-radius: 20px 20px 0 0;
                }
            }
            &__title {
                margin: 15px 0 0 0;
                max-width: 80%;
                overflow-y: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            &__subtitle {
                margin: 15px 0 30px 0;
                max-width: 80%;
                overflow-y: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            &__date {
                margin: 15px 0 0 0;
            }
            &__rate {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                &__img {
                    width: 20px;
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    @include large {
        .blog {
            &__status {
                flex-direction: row;
                &__item {
                    transition: all;
                    transition-duration: 0.5s;
                    cursor: pointer;
                    &:hover {
                        border: 1px solid $color-orange;
                        color: $color-orange;
                        transform: scale(1.1);
                    }
                }
            }
            &__articles {
                flex-direction: row;
                align-items: flex-start;
            }
            &__article {
                cursor: pointer;
                height: 400px;
                width: 30%;
                overflow-y: hidden;
                &__title {
                    grid-area: title;
                    cursor: pointer;
                    &__a {
                        text-decoration: none;
                    }
                }
                &__photo {
                    &__img {
                        height: 200px;
                        width: 100%;
                    }
                }
            }
        }
    }

</style>

<div class="blog">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Mes articles"/>
    {:else}
    <PageHeader props="My articles"/>
    {/if}
    <div class="bloc blog__bloc">
        <div class="blog__title">
            {#if ($storeLanguage == $lang_fr)}
            Vous retrouverez ici tous vos articles.
            {:else}
            Here you will find all your articles.
            {/if}
        </div>
        <div class="blog__add">
            {#if ($storeLanguage == $lang_fr)}
            <input class="button" type="submit" on:click={addArticle} value="Ajouter un article">
            {:else}
            <input class="button" type="submit" on:click={addArticle} value="Add an article">
            {/if}
        </div>
        <div class="blog__status">
            <div class="blog__status__item" on:click={() => handleAnchorClick("anchor-writing")} on:keydown={() => handleAnchorClick("anchor-writing")}>
                {#if ($storeLanguage == $lang_fr)}
                En cours de rédaction
                {:else}
                Writing
                {/if}
            </div>
            <div class="blog__status__item" on:click={() => handleAnchorClick("anchor-pending")} on:keydown={() => handleAnchorClick("anchor-pending")}>
                {#if ($storeLanguage == $lang_fr)}
                En cours de publication
                {:else}
                Being published
                {/if}
            </div>
            <div class="blog__status__item" on:click={() => handleAnchorClick("anchor-published")} on:keydown={() => handleAnchorClick("anchor-published")}>
                {#if ($storeLanguage == $lang_fr)}
                Publiés
                {:else}
                Published
                {/if}
            </div>
        </div>
        <div class="blog__anchor" id="anchor-writing"></div>
        <div class="blog__statusbloc">
            <div class="blog__statusbloc__title font__h2">En cours de rédaction</div>
            <div class="blog__articles">
                {#each myArticlesWriting as itemArticle, i}
                <div class="blog__article" on:click={() => selectArticle(itemArticle.id)} on:keydown={() => selectArticle(itemArticle.id)}>
                    <div class="blog__article__photo">
                        <img class="blog__article__photo__img" src="../assets/images/articles/{itemArticle.id}_{itemArticle.photo}" alt="article">
                    </div>
                    <div class="blog__article__title">
                        <div class="font__h3">
                            {#if ($storeLanguage == $lang_fr)}
                            {itemArticle.title_fr}
                            {:else}
                            {itemArticle.title_en}
                            {/if}
                        </div>
                    </div>
                    <div class="blog__article__subtitle font__h4">
                        {#if ($storeLanguage == $lang_fr)}
                        {itemArticle.subtitle_fr}
                        {:else}
                        {itemArticle.subtitle_en}
                        {/if}
                    </div>
                </div>
                {/each}
            </div>        
        </div>
        <div class="blog__anchor" id="anchor-pending"></div>
        <div class="blog__statusbloc">
            <div class="blog__statusbloc__title font__h2">Demande de publication en cours</div>
            <div class="blog__articles">
                {#each myArticlesPending as itemArticle, i}
                <div class="blog__article" on:click={() => selectArticle(itemArticle.id)} on:keydown={() => selectArticle(itemArticle.id)}>
                    <div class="blog__article__photo">
                        <img class="blog__article__photo__img" src="../assets/images/articles/{itemArticle.id}_{itemArticle.photo}" alt="article">
                    </div>
                    <div class="blog__article__title">
                        <div class="font__h3">
                            {#if ($storeLanguage == $lang_fr)}
                            {itemArticle.title_fr}
                            {:else}
                            {itemArticle.title_en}
                            {/if}
                        </div>
                    </div>
                    <div class="blog__article__subtitle font__h4">
                        {#if ($storeLanguage == $lang_fr)}
                        {itemArticle.subtitle_fr}
                        {:else}
                        {itemArticle.subtitle_en}
                        {/if}
                    </div>
                </div>
                {/each}
            </div>        
        </div>
        <div class="blog__anchor" id="anchor-published"></div>
        <div class="blog__statusbloc">
            <div class="blog__statusbloc__title font__h2">Publiés</div>
            <div class="blog__articles">
                {#each myArticlesPublished as itemArticle, i}
                <div class="blog__article" on:click={() => selectArticle(itemArticle.id)} on:keydown={() => selectArticle(itemArticle.id)}>
                    <div class="blog__article__photo">
                        <img class="blog__article__photo__img" src="../assets/images/articles/{itemArticle.id}_{itemArticle.photo}" alt="article">
                    </div>
                    <div class="blog__article__title">
                        <div class="font__h3">
                            {#if ($storeLanguage == $lang_fr)}
                            {itemArticle.title_fr}
                            {:else}
                            {itemArticle.title_en}
                            {/if}
                        </div>
                    </div>
                    <div class="blog__article__subtitle font__h4">
                        {#if ($storeLanguage == $lang_fr)}
                        {itemArticle.subtitle_fr}
                        {:else}
                        {itemArticle.subtitle_en}
                        {/if}
                    </div>
                </div>
                {/each}
            </div>        
        </div>
    </div>
</div>
